var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container",on:{"mouseenter":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[(_vm.visible)?_c('div',{ref:"tooltipBox",staticClass:"text-center",class:['tooltip-box', _vm.position]},[_vm._t("text")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }